import { useEffect, useState } from "react";

const SCENES = [
  { src: "/assets/film/scene-lettres.jpg", caption: "Des femmes et des hommes qui se passent le relais" },
  { src: "/assets/film/scene-plantation.jpg", caption: "Ensemble, on plante les racines de demain" },
  { src: "/assets/film/scene-maison.jpg", caption: "Une maison aux fondations solides, la porte ouverte aux familles" },
  { src: "/assets/film/scene-jardin.jpg", caption: "Un jardin où les enfants jouent, partagent et grandissent" },
  { src: "/assets/logo-full.png", caption: "Cœur d'École – Toury Famille — Association CETF", logo: true },
];
const DURATION = 5200;

export default function FilmSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % SCENES.length), DURATION);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      className="relative h-[44vh] sm:h-[54vh] lg:h-[60vh] overflow-hidden bg-slate-900"
      data-testid="film-section"
      aria-label="Film de présentation de l'association"
    >
      {SCENES.map((scene, i) => (
        <div
          key={scene.src}
          data-testid={`film-scene-${i}`}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          {scene.logo ? (
            <div className="w-full h-full bg-gradient-to-b from-sky-50 to-white flex items-center justify-center p-8">
              <img
                src={scene.src}
                alt="Logo Cœur d'École Toury Famille"
                className={`max-h-full max-w-full object-contain drop-shadow-xl ${i === index ? "ken-burns" : ""}`}
              />
            </div>
          ) : (
            <img
              src={scene.src}
              alt=""
              className={`w-full h-full object-cover ${i === index ? "ken-burns" : ""}`}
            />
          )}
        </div>
      ))}

      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-900/80 via-slate-900/30 to-transparent pt-20 pb-6 px-5 sm:px-8 pointer-events-none">
        <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-emerald-300 mb-1.5">
          Notre film
        </p>
        <p className="font-heading text-white text-lg sm:text-2xl font-bold max-w-2xl leading-snug" data-testid="film-caption">
          {SCENES[index].caption}
        </p>
        <div className="flex gap-2 mt-4">
          {SCENES.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Scène ${i + 1}`}
              data-testid={`film-dot-${i}`}
              className={`h-1.5 rounded-full transition-all duration-300 pointer-events-auto ${
                i === index ? "w-8 bg-emerald-400" : "w-3 bg-white/40 hover:bg-white/70"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
